import { useCallback } from "react";

import Box from "ds/components/Box";
import ProgressBar from "ds/components/ProgressBar";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";
import IconEmphasized from "ds/components/IconEmphasized";
import TileWrapper from "ds/components/Tile/Wrapper";
import TileContent from "ds/components/Tile/Content";
import TileTitle from "ds/components/Tile/Title";
import { ChevronRight, Clock } from "components/icons/generated";
import useUserGuideGroups from "shared/UserGuides/useUserGuideGroups";

import useAssistantPanelLearnStore from "../../useStore";
import styles from "./styles.module.css";
import AssistantPanelLearnGroupsViewSkeleton from "./Skeleton";

const AssistantPanelLearnGroupsView = () => {
  const { setNavigationState } = useAssistantPanelLearnStore();
  const { userGuideGroups, userGuidesCompletedCount, userGuidesCount, loading } =
    useUserGuideGroups();

  const handleGroupClick = useCallback(
    (groupId: string) => {
      setNavigationState({ level: "chapters", groupId });
    },
    [setNavigationState]
  );

  if (loading && !userGuideGroups) {
    return <AssistantPanelLearnGroupsViewSkeleton />;
  }

  return (
    <Box direction="column" padding="x-large" gap="large" grow="1" scrollable>
      <Box direction="column" gap="large">
        <Typography tag="p" variant="p-body3" align="center">
          Use our training program to learn about everything Spacelift can do.
        </Typography>
        <ProgressBar
          current={userGuidesCompletedCount}
          max={userGuidesCount}
          fullWidth
          isPercentage
          ariaLabel="Learning progress"
        />
      </Box>

      <Box direction="column" gap="medium" grow="1">
        {userGuideGroups?.map((group) => (
          <TileWrapper
            className={styles.tile}
            fullWidth
            onClick={() => handleGroupClick(group.id)}
            grow="0"
            key={group.id}
          >
            <TileContent gap="small">
              <Box align="center" fullWidth justify="between">
                <Box align="center" gap="medium">
                  <IconEmphasized icon={group.icon} backgroundColor={group.color} />
                  <Box direction="column">
                    <TileTitle variant="p-t7">{group.name}</TileTitle>
                    <Box direction="row" align="center" gap="small">
                      <Icon src={Clock} color="secondary" />
                      <Typography color="secondary" variant="p-body3" tag="span">
                        {group.timeToComplete}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Icon src={ChevronRight} color="secondary" />
              </Box>
            </TileContent>
          </TileWrapper>
        ))}
      </Box>
    </Box>
  );
};

export default AssistantPanelLearnGroupsView;
